<!-- FranchiseAppHeader.vue -->
<template>
	<header class="app-header-new">
		<div class="header-center">
			<input type="text" placeholder="Rechercher..." class="searchbar" v-model="searchQuery"
				@input="onSearchInput" />
			<i class="bi bi-search search-icon"></i>
		</div>
		<span class="separator"></span>
		<div class="header-right">
			<i class="bi bi-bell" style="display: none;"></i>
			<div class="user-info" ref="userPanel">
				<div class="top" @click="togglePanel">
					<p>{{ user.firstname }} {{ user.lastname }}</p>
					<!-- <i :class="['bi', isPanelOpen ? 'bi-chevron-up' : 'bi-chevron-down']"></i> -->
				</div>
			</div>
			<div v-if="isPanelOpen" class="user-panel">
				<!-- <p @click="profil">Mon Profil</p>
                <p>Paramètres</p> -->
				<p @click="logout">Se déconnecter</p>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "FranchiseAppHeader",
	props: ['user'],
	data() {
		return {
			isPanelOpen: false,
			isPanelPropOpen: false,
			searchQuery: ''
		};
	},
	created() {
	},
	mounted() {
		window.addEventListener("click", this.handleWindowClick);
	},
	methods: {
		togglePanel() {
			this.isPanelOpen = !this.isPanelOpen;
			if (this.isPanelPropOpen) this.isPanelPropOpen = !this.isPanelPropOpen;
		},
		onSearchInput() {
			this.$emit('search', this.searchQuery);
		},
		async profil() {
			this.$router.push(`/app/profil`);
			this.isPanelOpen = !this.isPanelOpen;
		},
		async logout() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "user/logout", { method: "GET", credentials: "include", });
				console.log(response.ok);
				if (response.ok) {
					this.$router.push("/login");
				} else {
					alert("Échec de la déconnexion");
				}
			} catch (error) {
				console.error("Erreur lors de la déconnexion:", error);
				alert("Erreur lors de la déconnexion");
			}
		},
		handleWindowClick(event) {
			if (this.$refs.userPanel && !this.$refs.userPanel.contains(event.target)) {
				this.isPanelOpen = false;
				this.isPanelPropOpen = false;
			}
		},
	},
	beforeUnmount() {
		window.removeEventListener("click", this.handleWindowClick);
	},
};
</script>

<style scoped>
.app-header-new {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 50px;
	color: white;
	gap: 50px;
}

.header-center {
	flex-grow: 1;
	display: flex;
	align-items: center;
}

.searchbar {
	padding: 20px;
	border: none;
	border-radius: 15px;
	width: 100%;
	box-sizing: border-box;
}

.search-icon,
.notification-icon,
.arrow-down-icon {
	cursor: pointer;
}

.search-icon {
	margin-left: -30px;
}

.header-right {
	position: relative;
	display: flex;
	align-items: center;
	flex-shrink: 0;
	gap: 50px;
}

.header-right i {
	font-size: 20px;
}

.separator {
	height: 50px;
	width: 2px;
	background-color: #c7c7c7;
}

.notification-icon {
	margin-right: 20px;
}

.user-info {
	white-space: nowrap;
	overflow: hidden;
	/* text-overflow: ellipsis; */
	max-width: 200px;
	cursor: pointer;
}

.user-info .top,
.user-info .bottom {
	display: flex;
	gap: 5px;
}

.user-info .bottom {
	justify-content: flex-end;
}

.user-info .top p,
.user-info .bottom p {
	color: #000;
	font-size: 18px;
	font-weight: bold;
	user-select: none;
	margin: 0;
	max-width: 180px;
	overflow: hidden;
}

.user-info .bottom p {
	color: #359590;
	font-size: 14px;
	margin-top: 2px;
}

.user-info .bottom i {
	color: #359590;
}

i {
	color: #000;
}

.user-panel,
.prop-panel {
	position: absolute;
	right: 0;
	top: 30px;
	background-color: white;
	border-radius: 5px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	padding: 10px;
	width: 200px;
	z-index: 10;
	overflow: hidden;
}

.prop-panel {
	top: 60px;
}

.user-panel p,
.prop-panel p {
	color: #333;
	padding: 10px;
	margin: 0;
	cursor: pointer;
}

.user-panel p:hover {
	background-color: #f0f0f0;
}

.prop-panel p {
	font-weight: bold;
	color: #359590;
	text-align: right;
}

.prop-panel p.current {
	position: relative;
	color: #fff;
	z-index: 1;
}

.prop-panel p.current:hover {
	background: none;
}

.prop-panel p.current::before {
	content: "";
	position: absolute;
	background-color: #359590;
	height: 32px;
	width: 220px;
	top: 5px;
	left: -10px;
	z-index: -1;
}

.prop-panel p:hover {
	position: relative;
	color: #fff;
	z-index: 1;
}

.prop-panel p:not(.current):hover::before {
	content: "";
	position: absolute;
	background-color: #359590;
	height: 32px;
	width: 220px;
	top: 5px;
	left: -10px;
	z-index: -1;
	opacity: 0.8;
}

.prop-panel hr {
	border: solid 1px #dcdcdc;
	width: 220px;
	margin-left: -11px;
}

.prop-panel a {
	font-weight: bold;
	color: #dcdcdc;
	display: block;
	text-align: right;
	text-decoration: none;
}

@media (max-width: 950px) {
	.app-header-new {
		padding: 10px;
		padding-left: 56px;
		gap: 10px;
	}

	.header-right {
		gap: 10px;
	}

	.searchbar {
		padding: 10px;
	}

	.user-info {
		max-width: 100px;
	}
}
</style>